import { ref, computed } from "vue";
import { environmentPreferences } from "@/utils/environmentPreferences";

// Estado compartilhado entre todos os componentes
const STORAGE_KEY = "ob_editor_mode_active";
const editorModeActive = ref(false);

// Inicializa do localStorage
const initEditorMode = () => {
  const stored = environmentPreferences.getItem(STORAGE_KEY);
  editorModeActive.value = stored === "true";
};

// Toggle editor mode
const toggleEditorMode = () => {
  editorModeActive.value = !editorModeActive.value;
  environmentPreferences.setItem(STORAGE_KEY, editorModeActive.value.toString());
};

// Verifica se está ativo
const isEditorModeActive = computed(() => editorModeActive.value);

export function useEditorMode() {
  return {
    editorModeActive: isEditorModeActive,
    toggleEditorMode,
    initEditorMode,
  };
}
